<div class="shell-router-outlet">
  <router-outlet></router-outlet>
</div>
